'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'box-open-full';
var width = 576;
var height = 512;
var aliases = ["box-full"];
var unicode = 'f49c';
var svgPathData = 'M304 128c0-44.2-35.8-80-80-80-32.4 0-60.2 19.2-72.8 46.9L109.4 71C130.4 28.9 173.8 0 224 0 256.7 0 286.6 12.3 309.2 32.5 318.1 13.3 337.5 0 360 0l64 0c30.9 0 56 25.1 56 56l0 7.4-3.7 2.1-44.3 25.3 0-34.8c0-4.4-3.6-8-8-8l-64 0c-4.4 0-8 3.6-8 8l0 80.5-60.6 34.6c8-12.4 12.6-27.3 12.6-43.1zM213 372.2l-116.9-66.8 0 41c0 14.5 7.9 27.9 20.6 35l147.4 81.9 0-100.7c-12 15-33.6 19.7-51 9.7zm16.2-46l27.7-60-178.6-99.2-30.1 55.8 181 103.4zM531.4 220.3l-3.4-5.7 0 131.7c0 32-17.3 61.4-45.3 76.9l-152 84.4c-26.6 14.8-58.9 14.8-85.5 0l-152-84.4C65.4 407.8 48 378.3 48 346.3l0-68.4-30.4-17.4C-1.2 249.8-8 226 2.3 206.9l48.6-90.3c3.1-5.8 8.4-10 14.7-11.7s13-.9 18.7 2.5L288 228.1 491.8 107.3c11.4-6.7 26-3 32.8 8.3l48 80c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2zM480 176.8l-168 93.3 0 193.1 147.4-81.9c12.7-7.1 20.6-20.4 20.6-35l0-169.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxOpenFull = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;